var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.45898,
    cy: 11,
    r: 8.95898,
    stroke: "#006EC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5996 13.6816V15H6.76367V13.875L9.52344 10.916C9.80078 10.6074 10.0195 10.3359 10.1797 10.1016C10.3398 9.86328 10.4551 9.65039 10.5254 9.46289C10.5996 9.27148 10.6367 9.08984 10.6367 8.91797C10.6367 8.66016 10.5938 8.43945 10.5078 8.25586C10.4219 8.06836 10.2949 7.92383 10.127 7.82227C9.96289 7.7207 9.75977 7.66992 9.51758 7.66992C9.25977 7.66992 9.03711 7.73242 8.84961 7.85742C8.66602 7.98242 8.52539 8.15625 8.42773 8.37891C8.33398 8.60156 8.28711 8.85352 8.28711 9.13477H6.59375C6.59375 8.62695 6.71484 8.16211 6.95703 7.74023C7.19922 7.31445 7.54102 6.97656 7.98242 6.72656C8.42383 6.47266 8.94727 6.3457 9.55273 6.3457C10.1504 6.3457 10.6543 6.44336 11.0645 6.63867C11.4785 6.83008 11.791 7.10742 12.002 7.4707C12.2168 7.83008 12.3242 8.25977 12.3242 8.75977C12.3242 9.04102 12.2793 9.31641 12.1895 9.58594C12.0996 9.85156 11.9707 10.1172 11.8027 10.3828C11.6387 10.6445 11.4395 10.9102 11.2051 11.1797C10.9707 11.4492 10.7109 11.7285 10.4258 12.0176L8.94336 13.6816H12.5996Z",
    fill: "#006EC2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.d3f715db51d7de20f2383132d5401500.svg";
export { ForwardRef as ReactComponent };